import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import cn from 'classnames';

import { BaseComponent } from '../../../../../components/BaseComponent';

import { HBox } from '../../../../../components/Box';
import CardComponent from '../../../../../containers/App/Components/Card/Card';
import { formatCurrency } from '../../../../../utils/string';
import { getTotalTradeInAmount } from '../../../helpers';

const STATE = {
  priceDetails: null,
};

/* eslint-disable react/prefer-stateless-function */
class OutgoingOrderTradeInCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  get selectedTradeInVehicles() {
    return this.props.selectedTradeInVehicles;
  }

  get total() {
    return this.props.total - getTotalTradeInAmount(this.selectedTradeInVehicles);
  }

  renderCard = () => {
    return (
      <CardComponent userPage title={<div>{this.lbl('vehicle.order.trade_in')}</div>}>
        <div className="p-2">
          {this.selectedTradeInVehicles?.map(v => {
            return (
              <HBox key={v?.id}>
                <h6>{v?.labelCard}</h6>
                <h6>{v?.price && formatCurrency(v?.price)}</h6>
              </HBox>
            );
          })}
        </div>
        <div className="p-2">
          <HBox>
            <label className="form-label">{this.lbl('vehicle.order.trade_in_car.total_price')}</label>
            <h6>{this.total && formatCurrency(this.total)}</h6>
          </HBox>
        </div>
      </CardComponent>
    );
  };

  render() {
    return this.renderCard();
  }
}

OutgoingOrderTradeInCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const OutgoingOrderTradeInCard = compose(withConnect, withRouter, injectIntl)(OutgoingOrderTradeInCardComp);
